'use client';

import { Box, Divider, Stack, Typography } from '@mui/material';

import { LabelsEditor } from '@/components/labels/labelsEditor';
import { RenameEntityName } from '@/components/wizard/renameEntityName';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';

/**
 * The policy name with its labels alongside. Labels are authored here rather than in a step of
 * their own because they describe the policy as a whole, not any one step's settings. Edits land
 * in the wizard's state as they are made, like the rest of the wizard: the step's own Save Changes
 * is what commits them.
 */
export const PolicyNameAndLabels = ({
  name,
  labels,
  focusOnName,
  onNameChange,
  onLabelsChange,
}: {
  name: string;
  labels: string[] | undefined;
  focusOnName?: boolean;
  onNameChange: (name: string) => void;
  onLabelsChange: (labels: string[]) => void;
}) => {
  const { PolicyAndVaultMetadataLabels = false } = useFeatureFlags();

  return (
    <Stack direction='row' sx={{ alignItems: 'center', gap: '16px' }}>
      <RenameEntityName
        focusOnMount={focusOnName}
        label='Backup policy name'
        name={name}
        onSubmit={onNameChange}
      />
      {PolicyAndVaultMetadataLabels && (
        <>
          <Divider
            orientation='vertical'
            flexItem
            sx={{ height: '20px', alignSelf: 'center' }}
          />
          <Stack direction='row' sx={{ alignItems: 'center', gap: '8px' }}>
            <Typography>Labels</Typography>
            {/* Capped so a policy carrying many labels cannot push the header wider than the step. */}
            <Box sx={{ minWidth: 0, maxWidth: '600px' }}>
              <LabelsEditor labels={labels} onChange={onLabelsChange} />
            </Box>
          </Stack>
        </>
      )}
    </Stack>
  );
};
